import React from 'react';
import styles from './CallToActionsList.module.scss';
import CallToActionListItem from '../CallToActionListItem/CallToActionListItem';
import { useTranslation } from 'react-i18next';

const CallToActionsList = ({ ctaList, onCtaClicked }) => {
  const { t } = useTranslation();

  return ctaList?.length ? (
    <ul className={styles.listContainer}>
      {ctaList.map(cta => (
        <CallToActionListItem item={cta} key={cta.id} onClick={onCtaClicked} />
      ))}
    </ul>
  ) : (
    <div className={styles.noAddedCtaContainer}>{t('call_to_action.editor.no_text_box')}</div>
  );
};

export default CallToActionsList;
